import { client } from './client';

export const feedbackApi = {
  sendFeedback: (params) => client.get('send_feedback', { params }),
  getMyFeedbackSummary: () => client.get('get_my_feedback_summary'),
  getFeedbackSummary: () => client.get('get_feedback_summary'),
  managerGetFeedbackSummary: () => client.get('manager_get_feedback_summary'),
  submitResponseRating: (params) => client.post('submit_response_rating', params),
  getMyResponseRating: (response_id) => client.get('get_my_response_rating', { params: { response_id } }),
  getDepartmentResponseRatings: (params) => client.get('get_department_response_ratings', { params }),
  getEmployeeResponseRatingDetails: (employee_id, params) => client.get('get_employee_response_rating_details', { params: { employee_id, ...params } }),
  getRatingContext: (rating_id) => client.get('get_rating_context', { params: { rating_id } }),
  getResponseRatingTimeSeries: (params) => client.get('get_response_rating_time_series', { params }),
  getResponseTimeSeries: (params) => client.get('get_response_time_series', { params }),
};
